import { IsUUID, ValidateIf } from 'class-validator';

/**
 * Body for `PATCH /iot/sensors/:id/equipment`.
 * `equipmentId: null` detaches the sensor from its equipment.
 */
export class UpdateIotSensorEquipmentDto {
  @ValidateIf((o: UpdateIotSensorEquipmentDto) => o.equipmentId !== null)
  @IsUUID()
  equipmentId!: string | null;
}
